module.exports = __webpack_public_path__ + "static/media/Costbanner@2x.d5dd963e.png";